/**
 * Accordion tools.
 */
H_Tools.accordions = (() => {
    /**
     * Closing duration of accordions. This should be same as CSS transition duration.
     */
    const closingDuration = 500;

    /**
     * Prevent the supplied accordion button from animating.
     *
     * @param {*} button An accordion button
     */
    function preventAnimation(button) {
        button.classList.add('-do-not-animate');
        setTimeout(
            (button) => {
                button.classList.remove('-do-not-animate');
            },
            closingDuration,
            button
        );
    }

    /**
     * Prevent the supplied accordion button from animating if the button is not in the visible
     * viewport.
     *
     * @param {*} button An accordion button
     */
    function preventAnimationIfNotVisible(button) {
        if (H_Tools?.stickyheader?.isElementVisible(button)) {
            return;
        }

        preventAnimation(button);
    }

    /**
     * Closes the accordion item associated with the supplied button.
     *
     * @param {*} button An accordion button
     */
    function closeAccordion(button) {
        button.setAttribute('aria-expanded', 'false');
        if (button.id) {
            localStorage.removeItem('accordion_state_' + button.id);
        }
    }

    /**
     * Closes all accordion items.
     */
    function closeAllAccordions() {
        const accordion_buttons = document.querySelectorAll(
            '.js-accordion-button'
        );

        accordion_buttons.forEach((button) => {
            preventAnimationIfNotVisible(button);
            closeAccordion(button);
        });
    }

    /**
     * Opens the accordion item associated with the supplied button.
     *
     * @param {*} button An accordion button
     */
    function openAccordion(button) {
        button.setAttribute('aria-expanded', 'true');
        if (button.id) {
            localStorage.setItem('accordion_state_' + button.id, 'open');
        }
    }

    /**
     * Immediately scroll to the supplied accordion button.
     *
     * @param {*} button An accordion button
     */
    function scrollToAccordion(button) {
        if (H_Tools?.stickyheader?.isElementVisible(button)) {
            return;
        }
        H_Tools?.stickyheader?.scrollTo(button, false);
    }

    /**
     * Toggle a single accordion item.
     *
     * @param {*} button An accordion button
     */
    function toggleAccordion(button) {
        const isClosed = button.getAttribute('aria-expanded') !== 'true';

        // Single item mode = whether or not only a single accordion item should be allowed open at
        // a given time. Currently single item mode depends on sticky header tools.
        const singleItemMode =
            H_Tools?.stickyheader &&
            button.getAttribute('data-single-item-mode-disabled') !== 'true';

        if (isClosed) {
            if (singleItemMode) {
                closeAllAccordions();
            }
            openAccordion(button);
        } else {
            closeAccordion(button);
        }

        if (singleItemMode) {
            scrollToAccordion(button);
        }
    }

    /**
     * Makes all accordions inside the supplied element open and close when clicked.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} el An element
     */
    function enableAccordions(el) {
        const accordion_buttons = el.querySelectorAll('.js-accordion-button');

        accordion_buttons.forEach((button) => {
            button.addEventListener('click', function () {
                toggleAccordion(this);
            });
        });
    }

    /**
     * Restores the state of all accordions inside the supplied element.
     *
     * @param {*} el An element
     */
    function restoreAccordionState(el) {
        // console.log('Restoring accordion state...');

        const accordion_buttons = el.querySelectorAll('.js-accordion-button');
        accordion_buttons.forEach((button) => {
            if (button.id) {
                if (localStorage.getItem('accordion_state_' + button.id)) {
                    preventAnimation(button);
                    openAccordion(button);
                }
            }
        });
    }

    // Return an object to expose inner functions
    return {
        enableAccordions: enableAccordions,
        restoreAccordionState: restoreAccordionState,
    };
})();
